const htmlTemplate = ({ body, customerId, orderDiscipline, orderPages, orderTopic }) =>
  `<div class="testimonial">
        <div class="testimonial__container">
            <div class="testimonial__date"><span>Topic title:</span> ${orderTopic} </div>
            <div class="testimonial__text">${body}</div>
                <div class="testimonial__date">
                ${orderDiscipline} |  ${orderPages} ${
    orderPages === 1 ? 'page' : 'pages'
  } | ID ${customerId}
                </div>
              </div>
    </div>`;

export default htmlTemplate;
